import { render, staticRenderFns } from "./assets_local.vue?vue&type=template&id=6a3dc730"
import script from "./assets_local.vue?vue&type=script&lang=js"
export * from "./assets_local.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports